var _g, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleBlurred = function SvgCircleBlurred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#circle-blurred_svg__clip0_12094_22973)",
    filter: "url(#circle-blurred_svg__filter0_b_12094_22973)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 64.5,
    fill: "#fff",
    fillOpacity: 0.05,
    strokeWidth: 2,
    stroke: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 65,
    r: 64.5,
    fill: "#fff",
    fillOpacity: 0.05,
    strokeWidth: 2,
    stroke: "#B277FD"
  })));
};
export { SvgCircleBlurred as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTMwIDEzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyMDk0XzIyOTczKSIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfYl8xMjA5NF8yMjk3MykiPgo8Y2lyY2xlIGN4PSI2NSIgY3k9IjY1IiByPSI2NC41IiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZT0id2hpdGUiLz4KPC9nPgo8Y2lyY2xlICBjeD0iNjUiIGN5PSI2NSIgcj0iNjQuNSIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC4wNSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2U9IiNCMjc3RkQiLz4KPC9zdmc+CgoKCg==";